module.exports = __webpack_public_path__ + "img/05-the-new-normal.04a87a19.jpg";